module.exports = __webpack_public_path__ + "img/wx-icon.89fdfa67.png";